module.exports = "::-webkit-input-placeholder { \r\n    font-style: italic; \r\n } \r\n :-moz-placeholder { \r\n    font-style: italic;   \r\n } \r\n ::-moz-placeholder { \r\n    font-style: italic;   \r\n } \r\n :-ms-input-placeholder {   \r\n    font-style: italic;  \r\n } \r\n .btn-add-org {\r\n\tmargin-left: 1em;\r\n} \r\n @media only screen and (max-width : 425px) {\r\n\r\n\t.btn-add-org {\r\n\t\tmargin-top: 1em !important;\r\n\t}\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search-organization/search-organization.component.css
// module id = ./src/app/shared/components/search-organization/search-organization.component.css
// module chunks = main